import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api/api";
import { setLoading } from "../../store/features/parkSlice";
import Loader from "../loader/Loader";
import Membership from "../ticket/Membership";

export default function Memberships() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.parkSlice);
  const { selectedBranch } = useSelector((state) => state.branchSlice);
  const [memberships, setMemberships] = useState([]);
  const fetch = useCallback(async () => {
    dispatch(setLoading(true));
    const res = await api.getMemberships(selectedBranch);
    if (res.status === 200) {
      setMemberships(res.data.data);
    }
    dispatch(setLoading(false));
  }, [selectedBranch, dispatch]);
  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <div className="d-flex gap-2 justify-content-center justify-content-md-start flex-wrap">
      {loading && (
        <div className="d-flex justify-content-center align-items-center pt-5 w-100">
          <Loader />
        </div>
      )}

      {!loading &&
        memberships.length > 0 &&
        memberships.map((item) => (
          <div
            key={item.id}
            style={{
              height: "322px",
              width: "230px",
            }}
          >
            <Membership item={item} />
          </div>
        ))}
    </div>
  );
}
